export * from './NavBarDetailsDesktop.ui';
